/**
 * License Release.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_RELEASE = 'license-release';
